import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, PLATFORMS } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="border-b border-[#2A2A2A]">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16">
          <p className="text-xs uppercase tracking-[0.25em] text-[#E4BD44] mb-4">Magazine</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">Blog Wildersquad</h1>
        </div>
      </section>
      <section className="border-b border-[#2A2A2A] bg-[#141414]">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-10">
          <p className="text-xs uppercase tracking-[0.25em] text-[#E4BD44] mb-5">Le ricette complete della CREW</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#2A2A2A] border border-[#2A2A2A]" data-testid="platforms-banner">
            {PLATFORMS.map((p) => (
              <a key={p.name} href={p.url} target="_blank" rel="noopener noreferrer"
                 className="bg-[#0A0A0A] hover:bg-[#141414] transition-colors p-6 group flex items-center justify-between"
                 data-testid={`platform-link-${p.name.toLowerCase()}`}>
                <div>
                  <p className="font-display text-xl font-bold">{p.name}</p>
                  <p className="text-xs text-[#9a9484] mt-1">{p.desc}</p>
                </div>
                <span className="text-[#E4BD44] group-hover:translate-x-1 transition-transform">→</span>
              </a>
            ))}
          </div>
        </div>
      </section>
      <section>
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
          {posts.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group" data-testid={`blog-card-${p.slug}`}>
              <div className="art-frame aspect-[16/10] border border-[#2A2A2A] mb-4">
                <img src={p.cover_url} alt={p.title} loading="lazy" />
              </div>
              <p className="text-[10px] uppercase tracking-[0.2em] text-[#E4BD44] mb-2">{p.category}</p>
              <h2 className="font-display text-2xl leading-snug mb-2 group-hover:text-[#E4BD44] transition-colors">{p.title}</h2>
              <p className="text-sm text-[#C9C4B8] leading-relaxed">{p.excerpt}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}

export function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setError(true));
  }, [slug]);

  if (error) return <div className="max-w-3xl mx-auto px-5 py-24 text-center font-display text-2xl">Articolo non trovato.</div>;
  if (!post) return <div className="max-w-3xl mx-auto px-5 py-24 text-center text-sm text-[#9a9484]">Caricamento…</div>;

  return (
    <article className="max-w-3xl mx-auto px-5 lg:px-10 py-16" data-testid="blog-post">
      <Link to="/blog" className="ws-link text-xs uppercase tracking-[0.2em] text-[#E4BD44]">← Torna al blog</Link>
      <p className="text-[10px] uppercase tracking-[0.2em] text-[#E4BD44] mt-8 mb-3">{post.category}</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight leading-tight mb-8">{post.title}</h1>
      <div className="art-frame aspect-[16/9] border border-[#2A2A2A] mb-10">
        <img src={post.cover_url} alt={post.title} />
      </div>
      <div className="text-base text-[#DDD8CC] leading-relaxed whitespace-pre-line" data-testid="blog-post-content">
        {post.content}
      </div>
    </article>
  );
}
